module.exports = __webpack_public_path__ + "static/media/phone-times.4db7a148.svg";